// extracted by mini-css-extract-plugin
module.exports = {"topProduct":"TopProduct_topProduct__P8VTy"};